import React from 'react';
import { motion } from 'framer-motion';
interface Level {
  title: string;
  description: string;
  focus: string;
}
const levels: Level[] = [{
  title: 'ELEMENTARY SCHOOL',
  description: 'Use clear visuals, shorter instructions, hands-on exploration and simplified creative challenges to build strong Art foundations.',
  focus: 'More exploration · Less written response · Clear visual support'
}, {
  title: 'MIDDLE SCHOOL',
  description: 'Move toward stronger technique, intentional choices, comparison, visual problem solving and more independent creative work.',
  focus: 'Technique · Decision-Making · Experimentation · Reflection'
}, {
  title: 'HIGH SCHOOL',
  description: 'Extend the same concepts through deeper analysis, more complex composition, independent projects, revision and evidence-based reflection.',
  focus: 'Independence · Analysis · Revision · Concept Development'
}];
export function GradeLevelsSection() {
  return <section className="w-full bg-navy px-5 py-10 sm:py-16" data-id="element-80" data-mp="hvya5o4yn0zj">
      <div className="mx-auto max-w-5xl" data-id="element-81" data-mp="hykoc6mcweqq">
        <div className="mx-auto max-w-2xl text-center" data-id="element-82" data-mp="cyq1ce5pc9ay">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-83" data-mp="ruxjl8xjv0nl">
            One System. Different Levels. Plenty of Room to Adapt.
          </h2>
          <p className="mt-3 text-sm text-white/70 sm:text-base" data-id="element-84" data-mp="mujcbt3rvuqm">
            THE COMPLETE ART YEAR™ supports Visual Arts teaching across Elementary, Middle School and
            High School without giving you three repetitive versions of the same material.
          </p>
        </div>
        <div className="mt-7 grid gap-4 sm:mt-9 sm:gap-6 md:grid-cols-3" data-id="element-85" data-mp="1akvstsd32zst">
          {levels.map((level, index) => <motion.div key={level.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-gold/40 bg-navy-mid p-6 sm:p-8" data-id="element-86" data-mp="15of0sn2rk1ag" data-mpi={index}>
              <h3 className="text-lg font-bold text-gold sm:text-xl" data-id="element-87" data-mp="1rkge4zllabl5">{level.title}</h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-white/85" data-id="element-88" data-mp="1wjt0lj8jtgn7">
                {level.description}
              </p>
              <span className="mt-4 inline-block w-fit rounded-full bg-gold/15 px-3 py-1 text-xs font-medium text-gold" data-id="element-89" data-mp="25eg0y0zcv2sl">
                {level.focus}
              </span>
            </motion.div>)}
        </div>
        <p className="mx-auto mt-6 max-w-2xl text-center text-sm leading-relaxed text-white/70 sm:mt-8 sm:text-base" data-id="element-90" data-mp="2fdf2z0pm806m">
          Look for built-in prompts such as “Make It Easier,” “Take It Further,” and “Advanced
          Challenge” to adjust the depth without rebuilding the lesson.
        </p>
      </div>
    </section>;
}